<template>
  <!--  SPINERS CARGA TABLA -->
  <div v-if="loadingComponent" class="spinner-container container-fluid">
    <Loading-Style/>
  </div>
  
  <div v-if="!loadingComponent && responseDATA && mostrarTabla">

      <div class="container container-fluid py-4">
        <div class="row">
          <div class="col-md-4">
            <label for="formName" class="form-label text-left">Nombre</label>
            <input type="text" class="form-control"  id="formName" v-model="formName"/>
          </div>
        </div>
      </div>

      <div class="table-container-scrollable-create">
        <table class="table table-striped table-hover table-bordered text-center table-rounded mt-2">
          <thead class="table-secondary">
            <tr>
              <th>ID</th>
              <th>Descripcion</th>
              <th>
                <div class="row">
                  <div class="col-md-6" >
                    Seleccione todos
                  </div>
                  <div class="col form-check form-switch">
                    <input 
                    type="checkbox"
                    class="form-check-input" 
                    v-model="selectAll" 
                    @change="toggleSelectAll" />
                </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody v-if="filteredData">
            <tr v-for="(row, index) in responseDATA" :key="index">
              <td>{{ row.id }}</td>
              <td>{{ row.description }}</td>
              <td>
                <ul class="">
                  <li>
                    <div class="form-check form-switch">
                      <input 
                        type="checkbox"
                        :id="'checkbox_' + index"
                        class="form-check-input"
                        :checked="filteredData[row.name] === 1"
                        @change="updateFilteredData(row.name, $event.target.checked ? 1 : 0)"
                      />
                      <label :for="'checkbox_' + index" class="form-check-label"></label>
                    </div>
                  </li>
                </ul> 
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-for="(customField, index) in customFields" :key="index">
        <div v-if="customField.value" class="form-group mt-3">
          <label class="form-label" :for="'custom_field_' + index">Campo personalizado {{ index + 1 }}</label>
          <div class="input-group">
            <input :id="'custom_field_' + index" type="text" placeholder="Nombre del nuevo campo"
              class="form-control" :name="'custom_field_' + index" v-model="customField.value" />
            <button @click="removeCustomField(index)" class="btn btn-custom">Eliminar</button>
          </div>
        </div>
      </div>

    <div @click="addCustomField" class="btn btn-secondary mt-3">Agregar Campo Personalizado</div>
  </div>

</template>

<script>
import { ref, onMounted, watch } from 'vue'
import apiAdmin from '../../../apis/Admin'
import { handleError } from '../../../Utils/StatusHandler'


export default {
  name: 'FormEditCompanyTertiary',
  emits: ['formData3'],
  props: {
      datosCompanyForm2: Object,
    },
  setup(props, { emit }) {
    const loadingComponent = ref(false);
    const response = ref(null);
    const responseDATA = ref(null);
    const propsCompany = ref([]);
    const errors = ref([]);
    const mostrarTabla = ref(true);
    const id = ref(null);
    const formName = ref(null);
    const customFields = ref([]);
    const selectedFields = ref({});
    const selectAll = ref(false);
    const filteredData = ref({});

    const handleErrors = (error) => {
      handleError(error, { errors });
    };

    const setDataValues = async () => {
      try {
        loadingComponent.value = true;
        const response = await apiAdmin.getFormsField();

        if (response) {
          const resultadosDATA = response.data;
          responseDATA.value = resultadosDATA.map(form => ({ ...form, selected: false }));
          
          if (props.datosCompanyForm2) {
            propsCompany.value = props.datosCompanyForm2;
            mostrarTabla.value = true;

            resultadosDATA.forEach(item => {
              if (propsCompany.value.hasOwnProperty(item.name)) {
                filteredData.value[item.name] = propsCompany.value[item.name];
              }
            });
            
            id.value = propsCompany.value.id
            formName.value = propsCompany.value.form_name

            Object.keys(propsCompany.value).forEach(key => {
              if (key.startsWith('custom_field_') && propsCompany.value[key] !== null) {
                customFields.value.push({ value: propsCompany.value[key] });
              }
            });

            if (propsCompany.value) {
              loadingComponent.value = false;
            }
          }
        }
      } catch (error) {
        console.error(error);
        handleErrors(error);
      }
    };

    const updateFilteredData = (fieldName, value) => {
      filteredData.value = { ...filteredData.value, [fieldName]: value };
      selectedFields.value = { ...selectedFields.value, [fieldName]: value };
      emitFormData();
    };

    const addCustomField = () => {
      customFields.value.push({ value: 'Editar Campo ***' });
    };

    const removeCustomField = (indexToRemove) => {
      const removedFieldValue = customFields.value[indexToRemove].value;
      customFields.value.splice(indexToRemove, 1);
      if (removedFieldValue) {
        customFields.value.push({ value: null });
      }
      emitFormData();
    };

    const emitFormData = () => {
      const updatedSelectedFields = Object.keys(selectedFields.value).reduce((acc, key) => {
        acc[key] = selectedFields.value[key] ? 1 : 0;
        return acc;
      }, {});

      emit('formData3', {
        component: 'FormEditCompanyTertiary',
        formData: {
          id: id.value,
          formName: formName.value,
          customFields: customFields.value,
          selectedFields: updatedSelectedFields,
        },
      });
    };

    const toggleSelectAll = () => {
      responseDATA.value.forEach(row => {
        row.selected = selectAll.value;
      });
    };

    watch(
      [formName, customFields, selectedFields],
      () => {
        emitFormData();
      },
      { deep: true }
    );

    onMounted(() => {
      setDataValues();
    });

    return {
      errors,
      loadingComponent,
      response,
      responseDATA,
      id,
      formName,
      customFields,
      selectAll,
      propsCompany,
      mostrarTabla,
      filteredData,
      toggleSelectAll,
      addCustomField,
      removeCustomField,
      emitFormData,
      updateFilteredData
    };
  },
};
</script>

